// import React from "react";

export const handleCopy = (text: string) => {
  navigator.clipboard.writeText(text)
    // .then(() => {
    //   alert('Copied to clipboard!');
    // })
    .catch((err) => {
      console.error('Failed to copy: ', err);
    });
};

export const handleEmailCopy = async (email: string, setIconState: (state: boolean) => void) => {
  try {
    await navigator.clipboard.writeText(email);
    setIconState(true); // Показываем CheckCheck иконку

    // Возвращаем иконку обратно к Mail через 2 секунды
    setTimeout(() => {
      setIconState(false);
    }, 2000);
  } catch (err) {
    console.error('Failed to copy email: ', err);
  }
};